// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"26ff307d","238":"4b89aaeb","257":"382bda01"}[chunkId] + ".chunk.js";
};